export interface errorNotificationType {
  ID_DEPARTMENT?: string;
  ID_FISCAL_YEAR?: string;
  ID_STRATEGY?: string;
  ID_TACTICS?: string;
  ID_PLAN?: string;
  START_DATE_PROJECT?: string;
  PROJECT_NAME?: string;
  ID_TYPE?: string;
  ID_CLUSTERS?: string;

  // BUDGET
  BUDGET?: string;

  ID_BUDGET?: string;
  PROJECT_EXTEND_END_DATE?:string;
}

export const initStateErrorMessage: errorNotificationType = {
  ID_DEPARTMENT: ``,
  ID_FISCAL_YEAR: ``,
  ID_STRATEGY: ``,
  ID_TACTICS: ``,
  ID_PLAN: ``,
  START_DATE_PROJECT: ``,
  PROJECT_NAME: ``,
  ID_TYPE: ``,
  ID_CLUSTERS: ``,
  BUDGET: ``,
  ID_BUDGET: ``,
  PROJECT_EXTEND_END_DATE:``
};

export const errorMessageText: errorNotificationType = {
  ID_DEPARTMENT: "กรุณาเลือกหน่วยงาน",
  ID_FISCAL_YEAR: "กรุณาระบุปีงบประมาณ",
  ID_STRATEGY: "กรุณาระบุยุทธศาสตร์",
  ID_TACTICS: "กรุณาระบุกลยุทธ์",
  ID_PLAN: "กรุณาระบุแผนงาน",
  START_DATE_PROJECT: "",
  PROJECT_NAME: "กรุณาระบุชื่อโครงการ",
  ID_TYPE: "กรุณาเลือกประเภทโครงการ",
  ID_CLUSTERS: "กรุณาเลือกประเภทกลุ่มภารกิจ",
  BUDGET: "กรุณาระบุงบประมาณรวม",
  ID_BUDGET: "กรุณาระบุแหล่งที่มาของงบประมาณ",
  PROJECT_EXTEND_END_DATE:``
};
